@if (currentConsentChrono !== undefined) {
  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>Consentement</ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" color="white" icon-only (click)="closeModal()">
          <ion-icon color="light" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
}

<ion-toolbar>
  <ion-icon name="navigate-circle" slot="start" color="primary"></ion-icon>
  <div class="title">Les fonctionnalités disponibles grâce à la géolocalisation</div>
</ion-toolbar>

<ion-content class="ion-padding">
  <form [formGroup]="consentForm" (ngSubmit)="saveConsent()">
    <p>En activant la géolocalisation de votre mobile, vous pouvez :</p>

    <ul>
      <li>Automatiser le calcul de vos temps d'activité pour vous simplifier la saisie au fil de l'eau;</li>
    </ul>

    <p>
      Votre position ne sera utilisée que durant vos heures de travail et lorsqu’un ordre de travail (OT) sera ouvert.
    </p>

    <ion-item lines="none">
      <ion-label>
        <strong>
          J'active la géolocalisation pour l'automatisation du calcul de des temps de trajet et d'intervention
        </strong>
      </ion-label>
      <ion-toggle slot="end" formControlName="geolocChrono"></ion-toggle>
    </ion-item>

    <p style="font-size: 0.9em; color: gray; font-style: italic">
      Vous pouvez à tout moment modifier vos choix dans les paramètres de l’application.
    </p>
    <div class="policies-container">
      <ion-checkbox class="consent-checkbox" slot="start" formControlName="acknowledged" />
      <ion-item lines="none">
        <ion-label class="acknowledgement-label">
          Je reconnais avoir pris connaissance de
          <a [attr.href]="privacyPolicyUrl() || null" [class.disabled-link]="!privacyPolicyUrl()" target="_blank">
            la politique interne de protection des données de Dalkia
          </a>
          décrivant les conditions de traitement de mes données personnelles et les droits dont je dispose ainsi que de
          <a
            [attr.href]="geolocationCharterUrl() || null"
            [class.disabled-link]="!geolocationCharterUrl()"
            target="_blank"
          >
            la charte de géolocalisation de Dalkia
          </a>
          décrivant tous les autres cas d’usages des données de géolocalisation du mobile professionnel pouvant
          légitimement être mis en oeuvre par Dalkia sans mon consentement préalable.
        </ion-label>
      </ion-item>
    </div>
    <ion-button id="submit" type="submit" expand="block" color="danger" [disabled]="consentForm.invalid">
      Enregistrer
    </ion-button>
  </form>
</ion-content>
